/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type InitiateAdyenTerminalPaymentV3Request,
    InitiateAdyenTerminalPaymentV3RequestFromJSON,
    InitiateAdyenTerminalPaymentV3RequestToJSON,
} from '../models/InitiateAdyenTerminalPaymentV3Request';
import {
    type InitiatePaymentV2Response,
    InitiatePaymentV2ResponseFromJSON,
    InitiatePaymentV2ResponseToJSON,
} from '../models/InitiatePaymentV2Response';

export interface InitiateAdyenTerminalPaymentRequest {
    initiateAdyenTerminalPaymentV3Request: InitiateAdyenTerminalPaymentV3Request;
}

/**
 * 
 */
export class PaymentV3ControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for initiateAdyenTerminalPayment without sending the request
     */
    async initiateAdyenTerminalPaymentRequestOpts(requestParameters: InitiateAdyenTerminalPaymentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['initiateAdyenTerminalPaymentV3Request'] == null) {
            throw new runtime.RequiredError(
                'initiateAdyenTerminalPaymentV3Request',
                'Required parameter "initiateAdyenTerminalPaymentV3Request" was null or undefined when calling initiateAdyenTerminalPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v3/inhouse/payments/terminal/adyen`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateAdyenTerminalPaymentV3RequestToJSON(requestParameters['initiateAdyenTerminalPaymentV3Request']),
        };
    }

    /**
     */
    async initiateAdyenTerminalPaymentRaw(requestParameters: InitiateAdyenTerminalPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatePaymentV2Response>> {
        const requestOptions = await this.initiateAdyenTerminalPaymentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatePaymentV2ResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateAdyenTerminalPayment(requestParameters: InitiateAdyenTerminalPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatePaymentV2Response> {
        const response = await this.initiateAdyenTerminalPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
